import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-slate-900 text-white" data-id="element-134">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-135">
        <img src="https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&q=80&w=2000" alt="Modern desert landscaping" className="w-full h-full object-cover opacity-40" data-id="element-136" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/70 to-slate-900/90" data-id="element-137" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-139">
          <span className="inline-block py-1 px-3 rounded-full bg-orange-500/10 text-orange-400 text-sm font-semibold tracking-wide mb-6 border border-orange-500/20" data-id="element-140">
            CASE STUDY: TFP LANDSCAPING
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 leading-tight" data-id="element-141">
            We Helped TFP Landscaping <br className="hidden md:block" data-id="element-142" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500" data-id="element-143">
              Nearly Double Their Competitor's
            </span>
            <br className="hidden md:block" data-id="element-144" /> Conversion Rate
          </h1>

          <p className="text-lg md:text-2xl text-slate-300 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-145">
            Real results from our automated marketing system over 6 months.
          </p>

          <motion.a href="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center px-8 py-4 text-lg font-bold text-white bg-orange-600 rounded-full shadow-lg hover:bg-orange-500 transition-colors group" data-id="element-146">
            See How We Can Help Your Business
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-147" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}